
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import { isBrowser } from 'react-device-detect';
import PN from 'persian-number'
import * as ReactDOM from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi'
import axios from 'axios';
import { Helmet } from "react-helmet";

const CompareProductIndex = () => {

    //#region Const 
    const toaster = rsuite.useToaster();
    const scrollToRef = React.useRef(null);
    const [SelectList, setSelectList] = React.useState([]);
    const [ResultList, setResultList] = React.useState([]);
    const [ProductList, setProductList] = React.useState([]);
    const [ParentList, setParentList] = React.useState([]);
    const [GroupList, setGroupList] = React.useState([]);
    const [ParentId, setParentId] = React.useState(-1);
    const [GroupId, setGroupId] = React.useState(-1);
    const [GroupClass, setGroupClass] = React.useState(isBrowser ? "" : "hide");
    const [ParentClass, setParentClass] = React.useState("");
    const [ProductClass, setProductClass] = React.useState(isBrowser ? "" : "hide");
    const [background, setbackground] = React.useState("../assets/Images/CompareProductBanner.png");
    const navigate = ReactDOM.useNavigate();
    const [columns, setColumns] = React.useState([]);



    const GetParentList = () => {
        setGroupList([]);
        setProductList([]);
        setSelectList([]);
        setResultList([]);
        trackPromise(

            fetch(General.ApiRoute() + '/ProductGroup/SearchForCompareWeb', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    "ParentId": 0,
                    'WebIsActive': 1,
                    'IsActive': -1,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Title: result[i].title,
                            Type: result[i].type,
                            Id: result[i].id,
                            Checked: 0,
                            Children: result[i].children


                        })
                    }
                    setParentList(tmp)
                })
        )
    }

    const SelectGroup = (check, id) => {
        setProductList([]);
        setSelectList([]);
        setResultList([]);
        var temp = [...GroupList];
        var index = temp.findIndex(x => x.id == id);

        if (index != -1) {
            temp[index].checked = check ? 1 : 0;

            var innerindex = [...ProductList].findIndex(x => x.id == id);
            if (innerindex == -1 && check == 1) {
                setProductList([
                    ...ProductList,
                    {
                        id: temp[index].id,
                        title: temp[index].title,
                        products: temp[index].products,
                    }

                ]);
            }
            else if (innerindex != -1 && check == 0) {
                var Ptemp = [...ProductList.filter(item => item.id !== id)];
                setProductList(Ptemp);
            }


        }
        setGroupList(temp);
    }

    const SelectPr = (check, id, groupId) => {
        if (SelectList.length < 4 || !check) {
            setResultList([]);

            var temp = [...ProductList];

            var index = temp.findIndex(x => x.id == groupId);

            if (index != -1) {
                var innerindex = temp[index].products.findIndex(x => x.id == id);
                if (innerindex != -1) {
                    temp[index].products[innerindex].checked = check ? 1 : 0;
                }
            }

            var selectindex = [...SelectList].findIndex(x => x == id);
            if (selectindex == -1 && check) {
                setSelectList([...SelectList, id]);


            }
            else if (selectindex != -1 && !check) {
                var stemp = [...SelectList.filter(item => item !== id)];
                setSelectList(stemp);
            }
            setResultList(temp);

        }
        else {

        }
    }


    const CompareProduct = () => {
        var RequestOptions = {
            data: {
                'Ids': SelectList,
            },
            url: General.ApiRoute() + "/ProductProperty/CompareProduct",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(result => {
                    var tmp = []
                    var columns = []
                    if (result.data.length > 0) {
                        var distinct = [];
                        for (var i = 0; i < result.data.length; i++) {
                            if (distinct.findIndex(item => item == result.data[i].title) == -1)
                                distinct.push(result.data[i].title)
                            if (columns.findIndex(x => x.label == result.data[i].title) == -1)
                                columns.push({
                                    label: result.data[i].title,
                                    key: result.data[i].title,
                                })
                        }
                        var columnCount = result.data.length / distinct.length;
                        for (var i = 0; i < columnCount; i++) {
                            if (SelectList.length == 2) {
                                tmp.push({
                                    row: i + 1,
                                    Id: result.data[i].id,
                                    [distinct[0]]: result.data[i].comment,

                                    [distinct[1]]: result.data[i + columnCount].comment,
                                    [distinct[2]]: result.data[i + columnCount * 2].comment,
                                })

                            }
                            else if (SelectList.length == 3) {
                                tmp.push({
                                    row: i + 1,
                                    Id: result.data[i].id,
                                    [distinct[0]]: result.data[i].comment,

                                    [distinct[1]]: result.data[i + columnCount].comment,
                                    [distinct[2]]: result.data[i + columnCount * 2].comment,
                                    [distinct[3]]: result.data[i + columnCount * 3].comment,
                                })

                            }
                            else if (SelectList.length == 4) {
                                tmp.push({
                                    row: i + 1,
                                    Id: result.data[i].id,
                                    [distinct[0]]: result.data[i].comment,

                                    [distinct[1]]: result.data[i + columnCount].comment,
                                    [distinct[2]]: result.data[i + columnCount * 2].comment,
                                    [distinct[3]]: result.data[i + columnCount * 3].comment,
                                    [distinct[4]]: result.data[i + columnCount * 4].comment,
                                })

                            }


                        }
                        setResultList(tmp)
                        setColumns(columns);
                    }
                    if (scrollToRef.current) {
                        scrollToRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                })
                .catch((error) => {
                    console.dir(error)
                })
        )




    }



    const ShowProduct = (id, title, Parent, Group) => {
        localStorage.setItem("ProductId", id);
        localStorage.setItem("ByBrand", false);
        localStorage.setItem("BySuggestion", false);
        localStorage.setItem("ByCompare", true);
        var parent = General.toSlug(Parent, { latin: true })
        var group = General.toSlug(Group, { latin: true })
        var product = General.toSlug(title, { latin: true })
        var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
        var Newproduct = product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") == "" ? product :
            product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
        window.location.href = '/ProductInfo/' + parent + "/" + group + "/" + Newproduct;

        // navigate('/ProductInfo/' + Parent + "/" + Group + "/" + title)

    }



    React.useEffect(() => {
        GetParentList();
        document.title = "مقایسه محصولات ";
    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className={isBrowser ? 'InnerBanner' : "InnerBanner_MobView"}
                // className={styles.article}
                style={{ backgroundImage: `url(${background})` }}
            >
            </div>
            <h1 className={isBrowser ? "InnerBanner-text " : "InnerBanner-text_MobView"}>مقایسه محصولات
                <div className={isBrowser ? "InnerBanner-sub-title" : 'hide'}>Product comparison </div>
            </h1>
            <h1 className="ProductInfoAddressBar ">
                <rsuite.Breadcrumb>
                    <rsuite.Breadcrumb.Item href="/">
                        خانه
                    </rsuite.Breadcrumb.Item>

                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682' }}>مقایسه محصولات</rsuite.Breadcrumb.Item>
                </rsuite.Breadcrumb>
            </h1>
            <rsuite.Panel className="pt-3">

                <rsuite.Card.Header  > <rsuite.Row >

                    <rsuite.Col xs={24}>
                        <rsuite.Button color="green" className="p-3" disabled={SelectList.length <= 1 ? true : false} onClick={() => CompareProduct()} appearance="primary" block>  شروع مقایسه</rsuite.Button>

                    </rsuite.Col>
                </rsuite.Row>
                </rsuite.Card.Header>

                <rsuite.Row className=" ">
                    <rsuite.Col xs={24} sm={24} md={8} lg={8} className={isBrowser ? "p-2" : "p-2 " + ParentClass}>
                        <rsuite.Card shaded className="w-100p " direction="row" >


                            <rsuite.Card.Header as="h6" className={isBrowser ? "hide" : "FarmAsan-bg p-3 text-truncate Font20 text-center"}>
                                انتخاب کنید
                            </rsuite.Card.Header>
                            <rsuite.Card.Body className=" h-70vh-y" >
                                <rsuite.RadioGroup name="Parent" value={ParentId}>
                                    {ParentList.map(pr => (


                                        <rsuite.List>
                                            <rsuite.List.Item onClick={(e) => (setParentId(pr.Id), setGroupList(pr.Children), setProductList([]), setSelectList([]), setResultList([]), setProductClass('hide'), setGroupClass(""), setParentClass('hide'))} className={pr.Id == ParentId ? "bg-light Font14 Cursor pe-2 ps-2" : " Font13 pe-2 Cursor ps-2"} key={pr.Id}>
                                                <rsuite.Row className={isBrowser ? "Font14" : " Font12"}>
                                                    <rsuite.Col className="" xs={24} sm={24} md={24} >
                                                        <rsuite.Radio
                                                            // inline
                                                            onChange={(e) => (setParentId(pr.Id), setGroupList(pr.Children), setProductList([]), setSelectList([]), setResultList([]), setProductClass('hide'), setGroupClass(""), setParentClass('hide'))}
                                                            value={pr.Id}
                                                            checked={pr.Id == ParentId}
                                                        />
                                                        {pr.Title}
                                                    </rsuite.Col>

                                                </rsuite.Row>

                                            </rsuite.List.Item>

                                        </rsuite.List>

                                    ))}
                                </rsuite.RadioGroup>

                            </rsuite.Card.Body>




                        </rsuite.Card>
                    </rsuite.Col>
                    <rsuite.Col xs={24} sm={24} md={8} lg={8} className={isBrowser ? "p-2 G" : "p-2 G " + GroupClass}>
                        <rsuite.Card shaded className="w-100p" direction="row" >


                            <rsuite.Card.Header as="h6" className={isBrowser ? "hide" : "FarmAsan-bg p-3 text-truncate Font20 text-center"}

                            >
                                <BiChevronRight className="Font20 float-end" onClick={() => (setProductClass('hide'), setGroupClass("hide"), setParentClass(''))} />
                                انتخاب نوع محصولات
                                <BiChevronLeft className={ProductList.length > 0 ? "Font20 float-start" : "hide"} onClick={() => (setProductClass(''), setGroupClass("hide"), setParentClass('hide'))} />

                            </rsuite.Card.Header>
                            <rsuite.Card.Body className=" h-70vh-y" >
                                {GroupList.map(pr => (

                                    <rsuite.List.Item onClick={(e) => SelectGroup(pr.checked == 1 ? 0 : 1, pr.id)} className={pr.checked == 1 ? "bg-light Font14 Cursor pe-2 ps-2" : " Font13 pe-2 Cursor ps-2"} key={pr.id}>
                                        <rsuite.Row className={isBrowser ? "Font14" : " Font12"}>
                                            <rsuite.Col className="" xs={24} sm={24} md={24} >
                                                <rsuite.Checkbox
                                                    // inline
                                                    checked={pr.checked}
                                                    onChange={(e, checked) => SelectGroup(checked, pr.id)}
                                                />
                                                {pr.title}
                                            </rsuite.Col>

                                        </rsuite.Row>

                                    </rsuite.List.Item>

                                ))}
                            </rsuite.Card.Body>




                        </rsuite.Card>
                    </rsuite.Col>
                    <rsuite.Col xs={24} sm={24} md={8} lg={8} className={isBrowser ? "p-2" : "p-2 " + ProductClass}>
                        <rsuite.Card shaded className="w-100p" direction="row" >

                            <rsuite.Card.Header as="h6" className={isBrowser ? "hide" : "FarmAsan-bg p-3 text-truncate Font20 text-center"}
                                onClick={() => (setProductClass('hide'), setGroupClass(""), setParentClass('hide'))}
                            >
                                انتخاب محصولات <BiChevronRight className="Font20 float-start" />

                            </rsuite.Card.Header>

                            <rsuite.Card.Body className=" h-70vh-y" >

                                {ProductList.map(pr => (
                                    <>
                                        <rsuite.Divider className="mt-4 pt-4">
                                            <rsuite.Heading className="mb-3" level={6}>{pr.title}</rsuite.Heading>
                                        </rsuite.Divider>

                                        <rsuite.List>

                                            {pr.products.map(inner =>
                                                <rsuite.List.Item onClick={(e) => SelectPr(inner.checked == 1 ? 0 : 1, inner.id, pr.id)} className={inner.checked == 1 ? " bg-light Font14 Cursor pe-2 ps-2" : " Font13 pe-2 Cursor ps-2"} key={inner.id}>
                                                    <rsuite.Row className={isBrowser ? "Font14" : " Font12"}>
                                                        <rsuite.Col className="" xs={24} sm={24} md={24} >
                                                            <rsuite.Checkbox
                                                                // inline
                                                                checked={inner.checked}
                                                                onChange={(e, checked) => SelectPr(checked, inner.id, pr.id)}
                                                            />
                                                            {inner.title}
                                                            {inner.current != 0 && inner.power != 0 ?
                                                                <small>
                                                                    <br />
                                                                    (جریان :  {inner.current} A  - توان :   {inner.power} KW)
                                                                </small>
                                                                : inner.power != 0 ?
                                                                    <small>
                                                                        <br />
                                                                        ( توان :   {inner.power} KW)
                                                                    </small>
                                                                    : inner.current != 0 ?
                                                                        <small>
                                                                            <br />
                                                                            (جریان :  {inner.current} A )
                                                                        </small>
                                                                        :
                                                                        ""
                                                            }
                                                        </rsuite.Col>
                                                    </rsuite.Row>

                                                </rsuite.List.Item>

                                            )
                                            }
                                        </rsuite.List>
                                    </>

                                ))}
                            </rsuite.Card.Body>




                        </rsuite.Card>
                    </rsuite.Col>

                    <rsuite.Col xs={24} className="p-2">
                        <rsuite.Card shaded direction="row" >
                            <div className="scroll-target" ref={scrollToRef}>

                                <rsuite.Card.Body className=" h-70vh-y" >
                                    <rsuite.Table
                                        height={500}
                                        wordWrap={isBrowser ? "" : "break-word"}
                                        headerHeight={isBrowser ? 30 : 70}
                                        align="start"
                                        data={ResultList}
                                    >
                                        {columns.map(column => (
                                            < rsuite.Table.Column key={column.key} fixed={column.key == "#" ? true : false} width={isBrowser ? 200 : 100} resizable >
                                                <rsuite.Table.HeaderCell>{column.label}</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey={column.key} />

                                            </rsuite.Table.Column>

                                        ))}
                                    </rsuite.Table>


                                </rsuite.Card.Body>
                            </div>



                        </rsuite.Card>
                    </rsuite.Col>

                </rsuite.Row>
            </rsuite.Panel>


        </Layout >
    )
}

export default CompareProductIndex;